import React from 'react'

import store from '~/core/store'
import { getTheme } from '~/selectors/ui'

import { THEMES } from '~/core/constants'
import Dark from './dark'
import Light from './light'

export default () => {
  const theme = getTheme(store.getState())
  return theme._name === THEMES.DARK ? <Dark role='presentation' /> : <Light role='presentation' />
}
